module.exports = __webpack_public_path__ + "static/Medusa-icon-b7ea48c45b4d61b6652553fdabc71faf.png";